import axios from "axios";

export default {
  namespaced: true,

  state: {
    all: {},
    currentTooltipPopup: null,
  },

  actions: {
    index({commit}) {
      return axios.get(process.env.VUE_APP_API_URL + 'settings')
        .then(({data}) => {

          let tooltips = {
            default: "Default tooltip"
          };

          for (let key in data) {
            const split = key.split("_");

            if (split[0] === 'tooltip') {
              tooltips[key] = data[key];
            }
          }

          commit('setItems', tooltips);
        });
    },
  },

  getters: {
    getAll(state) {
      return state.all;
    },
    getActiveTooltip(state) {
      return state.currentTooltipPopup;
    }
  },

  mutations: {
    setItems(state, obj) {
      state.all = obj;
    },

    setCurrentActive(state, val) {
      state.currentTooltipPopup = val;
    },

    setSelected(state, {index, bool}) {
      state.all[index].selected = bool;
    },
  },
}
